/**
 * Application-wide constants
 */

import { API_BASE_URL } from '../services/api';

// API Configuration
export const API = {
    ROOT_URL: process.env.REACT_APP_API_ROOT_URL || 'https://backend.leadslisting.in/api',
    BASE_PATH: '/api',
    TIMEOUT: 10000,
    ENDPOINTS: {
        BUSINESSES: '/businesses.php',
        LOGIN: '/login.php',
        REGISTER: '/register.php',
        LOGOUT: '/logout.php',
        CONTACT: '/send_email.php',
        UPLOAD: '/upload.php',
        PHOTOS: '/getPhotos.php'
    }
};

// Route paths
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    SIGNUP: '/signup',
    DASHBOARD: '/dashboard',
    ABOUT: '/about',
    CONTACT: '/contact',
    BUSINESS: {
        LIST: '/',
        ADD: '/add-business',
        EDIT: '/edit-business/:id',
        VIEW: '/view-business',
        DETAIL: '/business/:id'
    }
};

// Local storage keys
export const STORAGE_KEYS = {
    TOKEN: 'token',
    USER: 'user',
    THEME: 'theme'
};

// Message constants
export const MESSAGES = {
    SUCCESS: {
        LOGIN: 'Login successful!',
        LOGOUT: 'Logged out successfully!',
        BUSINESS_CREATED: 'Business created successfully!',
        BUSINESS_UPDATED: 'Business updated successfully!',
        BUSINESS_DELETED: 'Business deleted successfully!',
        CONTACT_SENT: 'Message sent successfully!'
    },
    ERROR: {
        LOGIN_FAILED: 'Invalid credentials',
        NETWORK_ERROR: 'Network error occurred',
        UNAUTHORIZED: 'Please login to continue',
        FORBIDDEN: 'You do not have permission to perform this action',
        NOT_FOUND: 'Resource not found',
        GENERAL: 'An error occurred. Please try again.'
    }
};

// Validation constants
export const VALIDATION = {
    EMAIL_REGEX: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    PHONE_REGEX: /^\+?[\d\s-]{10,}$/,
    MAX_LENGTH: {
        NAME: 100,
        // Increased to support long-form AI generated business descriptions (~800-1000 words with fallback padding)
        DESCRIPTION: 15000,
        ADDRESS: 200,
        PHONE: 20,
        EMAIL: 100
    }
};

// Theme constants
export const THEME = {
    COLORS: {
        PRIMARY: '#0d5097',
        SECONDARY: '#008000',
        SUCCESS: '#0d5097',
        DANGER: '#008000',
        WARNING: '#008000',
        INFO: '#0d5097',
        LIGHT: '#008000',
        DARK: '#008000'
    }
};

export function getImageUrl(photo) {
  if (!photo) return '/assets/images/default.jpg'; // fallback image
  if (photo.startsWith('http')) return photo; // absolute URL
  if (photo.startsWith('uploads/')) return `https://backend.leadslisting.in/api/${photo}`; // backend uploads
  return `/assets/images/${photo}`; // local image
}
